<template>
  <div class="pending-lineups">
    <div class="actions-bar">
      <div class="box left"></div>
      <div class="box right">
        <mds-button v-if="localPolicyOptions.options['submit-to-production']"
          id="submit-to-production" variation="primary"
          :disabled="!(itemsSelected !== 0)"
          @click="openSubmitModal"
        >
            Submit to Production
        </mds-button>
      </div>
    </div>

    <div class="grid-wrapper">
      <PendingLineupsChangesGrid @showToolTip="onShowTooltip" @hideToolTip="onHideTooltip" />
    </div>
  </div>
</template>
<script>
import { get } from 'lodash';
import { mapState } from 'vuex';
import { EventBus } from '@/utils/event-bus';
import PendingLineupsChangesGrid from '@/components/organisms/PendingLineupsChangesGrid';

export default {
  name: 'pending-lineups',
  computed: {
    ...mapState({
      policies: (state) => state.user.policies,
      selectedClient: (state) => state.pending.client.selected,
      selectedClientName: (state) => state.pending.client.name,
      searchTerm: (state) => state.pending.searchTerm,
      itemsSelected: (state) => state.pending.itemsSelected.total,
      itemsSelectedList: (state) => state.pending.itemsSelected.list,
      selectedTab: (state) => state.pending.tab,
    }),
    currentViewName() {
      return this.selectedClient > 0 ? 'one-client' : 'all-clients';
    },
    localPolicyOptions() {
      // Tabs are applied to both Views
      return get(this.policies, `pending.views.${this.currentViewName}.tabs.${this.selectedTab}`);
    },
  },
  components: {
    PendingLineupsChangesGrid,
  },
  created() {
    this.$store.dispatch('setPendingItemsSelected', {
      list: [],
      total: 0,
    });
    this.$store.dispatch('closeNotification');
    EventBus.$emit('pending-search-clear');
  },
  methods: {
    onShowTooltip(event, status, orientation, size) {
      this.$emit('showTooltip', event, status, orientation, size);
    },
    onHideTooltip(event) {
      this.$emit('hideTooltip', event);
    },
    openSubmitModal() {
      const count = this.itemsSelectedList.length;
      const funds = this.itemsSelectedList.reduce((ac, item) => [...ac, ...item], []);
      this.$store.dispatch('openModal', {
        title: 'Submit Lineup Changes',
        component: 'lineup-submit-changes',
        data: {
          count,
          funds,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.pending-lineups {
  flex: 1 1 100%;
  display: flex;
  flex-direction: column;
  position: relative;

  .grid-wrapper {
    height: calc(100% - 61px);
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;
  }
}

.actions-bar {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding-bottom: $mds-space-2-x;
  font-family: $mds-font-family-sans-serif;
  font-size: $mds-font-size-s;
  margin-top: $mds-space-2-x;

  .rowCount {
    font-weight: $mds-font-weight-light;
    margin: 0 $mds-space-4-x;
    flex-grow: 1;
  }

  button {
    margin-left: $mds-space-inset-2-x;
  }
}
</style>
